(function () {
  /* Meta Lead event — pushes `lead` to the dataLayer once per successful
     marketing signup so the GTM `Meta - Lead` tag can fire the website Lead
     event Meta needs for the "website + instant forms" conversion location.

     Runs ONLY under Cookiebot marketing consent: the GTM tag is gated on the
     same consent, so a non-consented push would never reach Meta anyway, and
     gating here also keeps the Klaviyo identify below from running.

     Where the signup happened tells us how to hook it:
       - Klaviyo forms (embedded blocks, popups, flyouts) dispatch `klaviyoForms`
         on window; `type === 'submit'` is the final submission.
       - Custom forms call window.myrqvistLead.track() after their own 2xx.
       - Dawn's newsletter form is a full-page POST; the success branch renders
         a [data-lead-signup] marker that is picked up on load. */

  var FBP_COOKIE = '_fbp';
  var FBC_COOKIE = '_fbc';
  var FBC_STORAGE = 'cc_fbc'; /* written by conversion-capture.js */
  /* Age past which Meta reports the fbclid inside an fbc value as expired. */
  var FBC_TTL_MS = 90 * 24 * 60 * 60 * 1000;

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  /* Mirrors conversion-capture.js: the _fbc cookie can outlive the click it
     encodes, so a value is judged on its own creation time; one that does not
     parse as fb.<idx>.<ms>.<id> passes through unjudged. */
  function freshFbc(value) {
    if (!value) return null;
    var match = /^fb\.\d+\.(\d{13})\./.exec(value);
    if (match && (Date.now() - parseInt(match[1], 10)) > FBC_TTL_MS) return null;
    return value;
  }

  function hasMarketingConsent() {
    return !!(typeof Cookiebot !== 'undefined' && Cookiebot.consent && Cookiebot.consent.marketing);
  }

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var idx = parts[i].indexOf('=');
      if (idx > -1 && parts[i].slice(0, idx) === name) {
        return decodeURIComponent(parts[i].slice(idx + 1));
      }
    }
    return null;
  }

  function makeEventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (e) {}
    /* UUID v4 fallback for browsers without crypto.randomUUID (older Safari). */
    var seed = Date.now();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (seed + Math.random() * 16) % 16 | 0;
      seed = Math.floor(seed / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  /* Stamp the event id and the Meta browser/click ids on the Klaviyo profile.
     Website leads have no Meta lead id, so fbp/fbc are what lets the CRM stage
     events match back to the ad click. Only done when the profile is known
     (email in hand) — an identify without one would land on an anonymous
     browser profile. Only reached through track(), so never without consent. */
  /* Same resolution as conversion-capture.js: fbq writes the _fbc cookie only
     after it loads under consent, so on the pageview that carries fbclid the
     cookie still holds the PREVIOUS click and the value conversion-capture
     synthesised from the URL is authoritative. On later pageviews the real
     cookie wins, with the stored value covering a pixel that never loaded
     (late consent, blocked fbq). */
  function currentFbc() {
    var stored = freshFbc(safeGet(FBC_STORAGE));
    if (stored && /[?&]fbclid=/.test(window.location.search)) return stored;
    return freshFbc(readCookie(FBC_COOKIE)) || stored;
  }

  function stampProfile(email, eventId) {
    var props = { $email: email, meta_lead_event_id: eventId };
    var fbp = readCookie(FBP_COOKIE);
    var fbc = currentFbc();
    if (fbp) props.meta_fbp = fbp;
    if (fbc) props.meta_fbc = fbc;
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', props]);
  }

  function track(source, opts) {
    if (!hasMarketingConsent()) return null;
    var eventId = makeEventId();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'lead', lead_source: source, lead_event_id: eventId });
    var email = opts && opts.email;
    if (email) stampProfile(email, eventId);
    return eventId;
  }

  /* One lead per form id per pageview: a re-dispatched `submit` for the same
     form (confirmation steps, retries) is the same signup, not a second one.
     A submit without a formId cannot be told apart from another id-less form,
     so it is neither deduped nor allowed to suppress a later one. */
  var trackedForms = {};

  window.addEventListener('klaviyoForms', function (e) {
    var detail = e && e.detail;
    if (!detail || detail.type !== 'submit') return;
    var formId = detail.formId;
    if (formId && trackedForms[formId]) return;
    var meta = detail.metaData || {};
    if (track('klaviyo_form:' + (formId || 'unknown'), { email: meta.$email }) && formId) {
      trackedForms[formId] = true;
    }
  });

  /* The Dawn newsletter POST redirects to ?customer_posted=true; the marker is
     rendered on that landing only. A reload or back/forward onto the same URL
     re-renders it, and so does a bookmarked, shared or address-bar-typed copy
     of that URL (navigation type `navigate`, but no referrer). The redirect
     that follows the real submit is the only `navigate` that arrives with the
     site's own page as referrer, so fire on that one alone.

     Consent may resolve after this deferred script runs (stored consent lands
     on CookiebotOnConsentReady, a fresh accept on CookiebotOnAccept), so the
     marker is retried on both and fires at most once. */
  var markersFired = false;

  function fireMarkers() {
    if (markersFired || !hasMarketingConsent()) return;
    var markers = document.querySelectorAll('[data-lead-signup]');
    if (!markers.length) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type !== 'navigate') return;
    if (document.referrer.indexOf(window.location.origin + '/') !== 0) return;
    markersFired = true;
    for (var i = 0; i < markers.length; i++) {
      /* No email survives the full-page POST, so no profile stamp: these
         leads match on hashed email/phone alone once Shopify syncs the
         subscriber to Klaviyo. */
      track(markers[i].getAttribute('data-lead-signup'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fireMarkers);
  } else {
    fireMarkers();
  }
  window.addEventListener('CookiebotOnConsentReady', fireMarkers);
  window.addEventListener('CookiebotOnAccept', fireMarkers);

  window.myrqvistLead = { track: track };
})();
